import { FC } from 'react';
import styled from 'styled-components';
import { Theme } from '../theme';

export interface StatusChipProps extends IntrinsicProps {
  id?: string;
  label: string;
  variation: keyof StatusChipType;
}

export type StatusChipType = {
  Draft: string;
  Scheduled: string;
  Triggered: string;
  Test: string;
  Live: string;
  Finished: string;
};

export type StatusChipsWrapperProps = Omit<StatusChipProps, 'id' | 'label'>;

function getColor(props: StatusChipsWrapperProps, theme: Theme) {
  switch (props.variation) {
    case 'Draft':
      return theme.designToken.warning500;
    case 'Scheduled':
      return theme.designToken.primary500;
    case 'Finished':
    case 'Test':
      return theme.designToken.secondary500;
    case 'Triggered':
    case 'Live':
      return theme.designToken.success300;
    default:
      return theme.designToken.warning500;
  }
}

const StatusChipsWrapper = styled.div<StatusChipsWrapperProps>`
  display: inline-flex;
  padding: 2px ${({ theme }) => theme.designToken.spacing2};
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.designToken.spacing3};
  border: 1px solid ${props => getColor(props, props.theme)};
  background: ${({ theme }) => theme.designToken.baseWhite};
`;
const Circle = styled.div<StatusChipsWrapperProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${props => getColor(props, props.theme)};
  width: 12px;
  height: 12px;
  margin-right: ${({ theme }) => theme.designToken.spacing1};
`;

const Label = styled.div`
  font: ${({ theme }) => theme.designToken.body2Semibold};
`;

export const StatusChip: FC<StatusChipProps> = ({ id, label, variation, ...props }) => {
  return (
    <StatusChipsWrapper data-testid={id} variation={variation} aria-label={props['aria-label']}>
      <Circle variation={variation} />
      <Label>{label.toUpperCase()}</Label>
    </StatusChipsWrapper>
  );
};
